import { paths } from '@/config/paths';
import { useModal } from '@/hooks/shared/use-modal';
// @ts-ignore
import SalesIcon from '@/images/sales-icon.svg?react';
import CreateSaleForm from '@/partials/sale/create-sale-form';
import { useNavigate } from 'react-router-dom';

export interface CreateSaleModalProps {}

export default function CreateSaleModal({}: CreateSaleModalProps) {
  const { close } = useModal();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4">
      {/* Content */}
      <div className="w-full">
        {/* Modal header */}
        <div className="mb-5 flex items-center gap-2">
          <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-gray-100 dark:bg-gray-700">
            <SalesIcon className="shrink-0 fill-current text-violet-500" />
          </div>
          <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">Skapa ny försäljning</div>
        </div>

        {/* Modal content */}
        <div className="text-sm space-y-3">
          <p>Skapa ny försäljning med nya produkter.</p>
          <CreateSaleForm
            onSuccess={({ id }) => {
              navigate(paths.sale.overview.getHref(id));
              close();
            }}
          />
        </div>
      </div>
    </div>
  );
}
